const moment = require("moment");
/**
 * @module app.prospection.store.callSummaryCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function CallSummaryCtrl($uibModalInstance, call) {
        let self = {};
        self.call = call;

        self.close = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    CallSummaryCtrl.$inject = ['$uibModalInstance','call'];

    angular
        .module('app.prospection.store.callSummaryCtrl', ['ui.bootstrap'])
        .controller('CallSummaryCtrl', CallSummaryCtrl);
});
